import React, { useEffect, useState } from 'react';
import { Card, Col, Container, Row } from 'reactstrap';
import { savePDF } from '@progress/kendo-react-pdf';
import { APIClient } from '../../helpers/api_helper';
import * as url from '../../helpers/url_helper';
import pdfImg from '../../assets/images/pdf-file.svg';
import StaticNavbar from './StaticNavbar';
import StaticFooter from './StaticFooter';
import TopBanner from './TopBanner';
import { toast } from 'react-toastify';
import Loader from '../../Components/Common/Loader';
import ActionPlanPDf from '../ActionPlanPDf';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import foodImg from '../../assets/images/food.svg';
import transportImg from '../../assets/images/transportation.svg';
import healthImg from '../../assets/images/clinical.svg';
import employmentImg from '../../assets/images/employment.svg';
import financeImg from '../../assets/images/finance.svg';
import houseImg from '../../assets/images/housing.svg';
import otherImg from '../../assets/images/others.svg';
import eduImg from '../../assets/images/education.svg';
import wifiImg from '../../assets/images/wifi.svg';
import legalImg from '../../assets/images/legal.svg';
import ServiceOrganizations from './ServiceOrganizations';
import noDataImg from '../../assets/images/noData.svg';

// xpIcons

import caregiver from '../../assets/icons/Caregiver.svg';
import clinical from '../../assets/icons/Clinical.svg';
import digital from '../../assets/icons/Digital.svg';
import employment from '../../assets/icons/Employment.svg';
import financial from '../../assets/icons/Financial.svg';
import food from '../../assets/icons/Food.svg';
import housing from '../../assets/icons/Housing.svg';
import interpersonal from '../../assets/icons/Interpersonal.svg';
import legal from '../../assets/icons/Legal.svg';
import literacy from '../../assets/icons/Literacy.svg';
import other from '../../assets/icons/Other.svg';
import social from '../../assets/icons/Social.svg';
import transportation from '../../assets/icons/Transportation.svg';
import physicalSafety from '../../assets/icons/physicalSafety.svg';
import { dateInRequireFormate, formSelectDefault, getEducationContentBasedOnFieldName } from '../../utils/Utils';
import Select from 'react-select';

const MainPage = () => {
    const textWrap = {
        wordBreak: 'break-word'
    };

    const api = new APIClient();
    const userData = useSelector((state) => state?.UserData?.data);
    const location = useLocation();
    const { lang, uniquelink, uniquekey, environment, languagesList, carePlanObj, xpLang } = location?.state || {};
    const [finalData, setFinalData] = useState({});
    const [showDrop, setShowDrop] = useState(null);
    const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
    const [generatePdf, setGeneratePdf] = useState(false);
    const [loader, setLoader] = useState(false);
    const [serviceOrgData, setServiceOrgData] = useState({});
    const [showOrgs, setShowOrgs] = useState(false);

    const [collapsed, setCollapsed] = useState([]);
    const [collapsedPrograms, setCollapsedPrograms] = useState([]);
    const [collapsedOrganizations, setCollapsedOrganizations] = useState({});
    const [Content, setContent] = useState({});
    const [selecteLanguage, setSelectedLanguage] = useState(null);
    let content = {};

    const getContent = () => {
        setLoader(true);
        getData();
    };

    const getData = () => {
        if (environment === 'xp') {
            if (userData?.apiKey !== '' && userData?.token !== '') {
                // setLoader(true);
                api.newGet(url.GET_MEMBER_CARE_PLAN(uniquelink, uniquekey), {
                    apiKey: userData?.apiKey,
                    auth: userData?.token
                })
                    .then((res) => {
                        if (res?.isSuccess) {
                            if (res?.warnings > 0) {
                                toast.warning(res?.warnings?.[0]);
                                setLoader(false);
                            } else {
                                if (res?.data && res?.data !== null) {
                                    setFinalData(res?.data);
                                    setLoader(false);
                                } else {
                                    setLoader(false);
                                }
                            }
                        } else {
                            toast.error(res?.message?.[0]);
                            setLoader(false);
                        }
                    })
                    .catch((err) => {
                        toast.error(err);
                        setLoader(false);
                    });
            }
        } else {
            if (userData?.apiKey !== '' && userData?.token !== '') {
                setLoader(true);
                api.newGet(url.GET_MEMBER_CARE_PLAN_LEGACY(uniquelink), {
                    apiKey: userData?.apiKey,
                    auth: userData?.token
                })
                    .then((res) => {
                        if (res?.isSuccess) {
                            if (res?.warnings > 0) {
                                toast.warning(res?.warnings?.[0]);
                            } else {
                                setFinalData(res?.data);
                            }
                            setLoader(false);
                        } else {
                            toast.error(res?.message?.[0]);
                            setLoader(false);
                        }
                    })
                    .catch((err) => {
                        toast.error(err);
                        setLoader(false);
                    });
            }
        }
    };

    useEffect(() => {
        getContent();
        const language = languagesList?.find((obj) => obj?.value === lang?.toUpperCase());
        setSelectedLanguage(language);
        content = carePlanObj?.[language?.value];
        setContent(content);
    }, []);

    const handleAccorShow = (idx) => {
        setShowDrop((prev) => (prev === idx ? null : idx));
        setOpenDropdownIndex(null);
    };

    const callIconApI = (data) => {
        api.newGet(url.GET_ICONS_URL(uniquelink, uniquekey), {
            apiKey: userData?.apiKey,
            auth: userData?.token
        })
            .then((res) => {
                const parsedData = JSON.parse(res?.data);
                const Iconddata = parsedData[0]?.Data;
                const updatedNeedData = data?.needDetailsTypes?.map((needDetail) => {
                    const matchingIcon = Iconddata?.find((icon) => icon?.category === needDetail?.needCategory);
                    if (matchingIcon) {
                        return {
                            ...needDetail,
                            needCategoryIconClass: matchingIcon?.categoryIconClass ? JSON.parse(matchingIcon?.categoryIconClass) : ''
                        };
                    }

                    // If no match, return the needDetail as is
                    return needDetail;
                });
                data.needDetailsTypes = updatedNeedData;
                const finalCareData = data;
                setFinalData(finalCareData);
                setLoader(false);
            })
            .catch((err) => {
                // toast.error(err);
                setFinalData(data);
                setLoader(false);
            });
    };

    const handleCollapse = (index) => {
        setCollapsed((prevState) => {
            const newState = [...prevState];
            newState[index] = !newState[index];
            return newState;
        });
    };

    const handleProgramCollapse = (categoryIndex) => {
        setCollapsedPrograms((prev) => {
            const newCollapseState = [...prev];
            newCollapseState[categoryIndex] = !newCollapseState[categoryIndex];
            return newCollapseState;
        });
    };

    const handleOrganizationCollapse = (categoryIndex, programIndex, orgIndex) => {
        setCollapsedOrganizations((prev) => {
            const updatedState = { ...prev };
            const categoryKey = `${categoryIndex}-${programIndex}`;
            if (!updatedState[categoryKey]) {
                updatedState[categoryKey] = [];
            }
            updatedState[categoryKey][orgIndex] = !updatedState[categoryKey][orgIndex];
            return updatedState;
        });
    };

    // for showing timings as per mockup
    const toggleDropdown = (index) => {
        setOpenDropdownIndex(openDropdownIndex === index ? null : index);
    };

    const workingHours = [
        'Monday: 9 AM - 5 PM',
        'Tuesday: 9 AM - 5 PM',
        'Wednesday: 9 AM - 5 PM',
        'Thursday: 9 AM - 5 PM',
        'Friday: 9 AM - 5 PM',
        'Saturday: 9 AM - 1 PM',
        'Sunday: 9 AM - 12 PM'
    ];

    const handleCatgIcon = (item) => {
        if (!item) return otherImg; // Handle undefined/null input

        switch (true) {
            case item.includes('Employment'):
            case item.includes('Literacy'):
                return employmentImg;

            case item.includes('Housing'):
            case item.includes('Insecurity'):
                return houseImg;

            case item.includes('Transportation'):
                return transportImg;

            case item.includes('Education'):
            case item.includes('Literacy'): // Duplicate check removed
                return eduImg;

            case item.includes('Digital'):
            case item.includes('Broadband'):
                return wifiImg;

            case item.includes('Legal'):
            case item.includes('Justice'):
                return legalImg;

            case item.includes('Financial'):
            case item.includes('Hardship'):
                return financeImg;

            case item.includes('Clinical'):
            case item.includes('Barriers'):
                return healthImg;

            case item.includes('Food'):
                return foodImg;

            default:
                return otherImg;
        }
    };

    const xphandleCatgIcon = (item) => {
        if (!item) return other; // Handle undefined/null input

        switch (true) {
            case item.includes('Clinical'):
                return clinical;
            case item.includes('Financial'):
                return financial;
            case item.includes('Employment'):
                return employment;
            case item.includes('Transportation'):
                return transportation;
            case item.includes('Housing'):
                return housing;
            case item.includes('Literacy'):
                return literacy;
            case item.includes('Physical'):
                return physicalSafety;
            case item.includes('Caregiver'):
                return caregiver;
            case item.includes('Food'):
                return food;
            case item.includes('Legal'):
                return legal;
            case item.includes('Other'):
                return other;
            case item.includes('Interpersonal'):
                return interpersonal;
            case item.includes('Digital'):
                return digital;
            case item.includes('Social'):
                return social;
            default:
                return other;
        }
    };

    const handlePdfDownload = () => {
        setGeneratePdf(true);

        const actionPdfElement = document.getElementById('actionPdf');
        actionPdfElement?.classList.remove('d-none');

        const el = document.querySelector('.download-action-pdf');
        const copy = el.cloneNode(true);

        const element = document.createElement('div');
        element.setAttribute('id', 'test');
        element.appendChild(copy);

        document.body.appendChild(element);

        addBootstrapStyles().then(() => {
            savePDF(
                element,
                {
                    repeatHeaders: true,
                    paperSize: 'A4',
                    margin: '.2cm',
                    scale: 0.5,
                    fileName: 'Care Plan'
                },
                () => {
                    document.getElementById('test')?.remove();
                    actionPdfElement?.classList.add('d-none');

                    setTimeout(() => {
                        setGeneratePdf(false);

                        const linkToRemove = document.getElementById('bootstrap-css');
                        if (linkToRemove) {
                            linkToRemove.remove();
                        }
                    }, 1000);
                }
            );
        });
    };

    const onClickServiceOrg = (i, program) => {
        const programData = program;
        setServiceOrgData(programData);
        setShowOrgs(true);
    };

    const addBootstrapStyles = () => {
        return new Promise((resolve) => {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = 'https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css';
            link.id = 'bootstrap-css';

            link.onload = () => resolve(link);

            document.head.appendChild(link);
        });
    };

    return (
        <>
            {(generatePdf || loader) && (
                <div className="freeze-spinner">
                    <Loader />
                </div>
            )}
            <StaticNavbar data={finalData} lang={lang} userToken={uniquelink} userKey={uniquekey} pathFor={environment} xpLang={xpLang} />
            {environment === 'xp' ? (
                <Container fluid>
                    <TopBanner data={finalData} Content={Content} />
                    {!showOrgs && (
                        <Row className="mt-3">
                            <Col>
                                <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
                                    {/* Left Side - Needs Count */}
                                    <div className="fs-5">{`Needs(${finalData?.needDetailsTypes?.length || 0})`}</div>

                                    {/* Right Side - Language Select & PDF Download */}
                                    {finalData && Object.keys(finalData).length > 0 && (
                                        <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-3 ms-md-auto">
                                            {/* Language Select */}
                                            <div className="d-flex align-items-center">
                                                <span className="me-2">Language</span>
                                                <Select
                                                    value={selecteLanguage}
                                                    onChange={(evt) => {
                                                        setSelectedLanguage(evt);
                                                        const lang = evt?.value;
                                                        const content = carePlanObj?.[lang];
                                                        setContent(content);
                                                    }}
                                                    className="w-100"
                                                    options={languagesList}
                                                    components={{ IndicatorSeparator: () => null }}
                                                    styles={formSelectDefault}
                                                />
                                            </div>

                                            {/* Download PDF */}
                                            <div
                                                className="fs-5 text-info cursor-pointer d-flex align-items-center"
                                                onClick={handlePdfDownload}
                                            >
                                                <img src={pdfImg} alt="pdf-img" width={27} className="me-2" />
                                                <span>Download PDF</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    )}
                    {!showOrgs && (
                        <Row className="mt-3">
                            {finalData && finalData !== null && Object.keys(finalData).length > 0 ? (
                                <>
                                    {finalData?.needDetailsTypes?.length > 0 ? (
                                        <>
                                            {finalData?.needDetailsTypes?.map((need, index) => (
                                                <Col lg={6} sm={12} md={12} xxl={12} xl={6} key={index}>
                                                    <Card
                                                        className={`p-3 cursor-pointer rounded${
                                                            showDrop === index ? 'border border-success' : ''
                                                        }`}
                                                    >
                                                        <div
                                                            className={`d-flex justify-content-between align-items-center ${
                                                                showDrop === index ? 'border-bottom-dashed border-light' : ''
                                                            }`}
                                                            onClick={() => handleAccorShow(index)}
                                                        >
                                                            <div className="d-flex align-items-center">
                                                                <span className="me-3">
                                                                    <img
                                                                        src={xphandleCatgIcon(need?.needCategory)}
                                                                        alt=""
                                                                        className="text-primary img-h25"
                                                                    />
                                                                    {/* <i
                                                                        class={`fa-solid ${need?.needCategoryIconClass?.icon} fa-2x ${need?.needCategoryIconClass?.colour}`}
                                                                    ></i> */}
                                                                </span>
                                                                <p className="fs-5 mb-0">{need?.needCategory}</p>
                                                            </div>
                                                            <span>
                                                                <i
                                                                    className={`ri-arrow-${
                                                                        showDrop === index ? 'down' : 'right'
                                                                    }-s-line fs-1 text-success`}
                                                                ></i>
                                                            </span>
                                                        </div>
                                                        {showDrop === index && (
                                                            <>
                                                                {need.programs.length > 0 ? (
                                                                    need?.programs?.map((program, idx) => (
                                                                        <div
                                                                            className={`d-flex justify-content-between align-items-center m-2 p-2 mt-1 border-bottom   ${
                                                                                program?.isProgramDisable ? 'table-grey' : ''
                                                                            }`}
                                                                            key={idx}
                                                                        >
                                                                            <div>
                                                                                <h5
                                                                                    className={`m-0 ${
                                                                                        program?.isProgramDisable
                                                                                            ? 'text-muted'
                                                                                            : 'text-dark'
                                                                                    } font-weight-bold `}
                                                                                >
                                                                                    {program?.programName ? program?.programName : null}
                                                                                </h5>
                                                                                {program?.serviceOrganizations?.length > 0 ? (
                                                                                    <div onClick={() => onClickServiceOrg(idx, program)}>
                                                                                        <h7
                                                                                            className={` ${
                                                                                                program?.isProgramDisable
                                                                                                    ? 'text-muted'
                                                                                                    : 'text-info'
                                                                                            }  `}
                                                                                        >
                                                                                            {program?.serviceOrganizations?.length > 1
                                                                                                ? `${
                                                                                                      program?.serviceOrganizations?.length
                                                                                                  } ${
                                                                                                      carePlanObj?.[selecteLanguage?.value]
                                                                                                          ?.multiAgency
                                                                                                  } `
                                                                                                : `${
                                                                                                      program?.serviceOrganizations?.length
                                                                                                  } ${
                                                                                                      carePlanObj?.[selecteLanguage?.value]
                                                                                                          ?.singleEgency
                                                                                                  } `}
                                                                                        </h7>
                                                                                    </div>
                                                                                ) : (
                                                                                    <>
                                                                                        {Content?.noData?.map((item, index) => (
                                                                                            <h7 class="text-muted cursor-none">
                                                                                                {item?.content}
                                                                                            </h7>
                                                                                        ))}
                                                                                    </>
                                                                                )}
                                                                                {!!program?.education && (
                                                                                    <div>
                                                                                        {getEducationContentBasedOnFieldName(
                                                                                            program?.education,
                                                                                            'Description',
                                                                                            selecteLanguage?.value
                                                                                        )}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                ) : (
                                                                    <>
                                                                        <div className="p-5 text-center">
                                                                            {Content?.noContent?.map((item, index) => (
                                                                                <div>{item?.content}</div>
                                                                            ))}
                                                                        </div>
                                                                        {/* <div className="p-5 text-center">
                                                                        <div>A resource is not yet available for this need.</div>
                                                                        <div>
                                                                            As soon your care plan is updated, we will notify you using your
                                                                            preferred communication method.
                                                                        </div>
                                                                    </div> */}
                                                                    </>
                                                                )}
                                                            </>
                                                        )}
                                                    </Card>
                                                </Col>
                                            ))}
                                        </>
                                    ) : (
                                        <>
                                            <div className="d-flex justify-content-center align-items-center">
                                                <img src={noDataImg} alt="pdf-img" className="img-fluid" />
                                            </div>
                                            <div className="p-5 text-center">
                                                {Content?.noContent?.map((item, index) => (
                                                    <div>{item?.content}</div>
                                                ))}
                                            </div>
                                            {/* <div className="p-5 text-center">
                                            <div>A resource is not yet available for this need.</div>
                                            <div>
                                                As soon your care plan is updated, we will notify you using your preferred communication
                                                method.
                                            </div>
                                        </div> */}
                                        </>
                                    )}
                                </>
                            ) : (
                                <>
                                    <div className="d-flex justify-content-center align-items-center">
                                        <img src={noDataImg} alt="pdf-img" className="img-fluid" />
                                    </div>
                                    <div className="p-5 text-center">
                                        {Content?.noContent?.map((item, index) => (
                                            <div>{item?.content}</div>
                                        ))}
                                    </div>

                                    {/* <div className="p-5 text-center">
                                    <div>A resource is not yet available for this need.</div>
                                    <div>
                                        As soon your care plan is updated, we will notify you using your preferred communication method.
                                    </div>
                                </div> */}
                                </>
                            )}
                        </Row>
                    )}
                    {showOrgs && (
                        <ServiceOrganizations
                            serviceOrgData={serviceOrgData}
                            onCloseClick={() => {
                                setShowOrgs(false);
                            }}
                            content={carePlanObj?.[selecteLanguage?.value]}
                        ></ServiceOrganizations>
                    )}
                    <div className="d-none download-action-pdf" id="actionPdf">
                        <ActionPlanPDf dataForPDf={finalData} pdfFor={environment} Content={Content} />
                    </div>
                </Container>
            ) : (
                <Container fluid>
                    <TopBanner data={finalData} />
                    <Row className="mt-3">
                        <Col>
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="fs-5">{`Needs(${finalData?.needs?.length ? finalData?.needs?.length : 0})`}</div>
                                {finalData && finalData !== null && Object.keys(finalData).length > 0 && (
                                    <div className="fs-5 text-info cursor-pointer" onClick={handlePdfDownload}>
                                        <span>
                                            <img src={pdfImg} alt="pdf-img" width={27} className="me-2" />
                                        </span>
                                        Download PDF
                                    </div>
                                )}
                            </div>
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        {finalData && finalData !== null && Object.keys(finalData).length > 0 ? (
                            <>
                                {finalData?.needs?.length > 0 ? (
                                    <>
                                        {finalData?.needs?.map((need, index) => (
                                            <Col lg={6} sm={12} md={12} xxl={12} xl={6} key={index}>
                                                <Card className={`p-3 cursor-pointer ${showDrop === index ? 'border border-success' : ''}`}>
                                                    <div
                                                        className={`d-flex justify-content-between align-items-center ${
                                                            showDrop === index ? 'border-bottom' : ''
                                                        }`}
                                                        onClick={() => handleAccorShow(index)}
                                                    >
                                                        <div className="d-flex align-items-center">
                                                            <span className="me-3">
                                                                <img src={handleCatgIcon(need?.category)} alt="" className="text-primary" />
                                                            </span>
                                                            <p className="fs-5 mb-0">{need?.category}</p>
                                                        </div>
                                                        <span>
                                                            <i
                                                                className={`ri-arrow-${
                                                                    showDrop === index ? 'down' : 'right'
                                                                }-s-line fs-1 text-success`}
                                                            ></i>
                                                        </span>
                                                    </div>
                                                    {showDrop === index &&
                                                        (need?.serviceOrganizations?.length > 0 ? (
                                                            <>
                                                                <p className="fs-6 mb-0 my-3 text-muted">
                                                                    Below are the suggested local agencies :
                                                                </p>
                                                                <Row className="mt-2">
                                                                    {need?.serviceOrganizations?.map((item, idx) => (
                                                                        <Col
                                                                            lg={6}
                                                                            sm={12}
                                                                            md={12}
                                                                            xxl={4}
                                                                            xl={6}
                                                                            key={idx}
                                                                            className="mb-3"
                                                                        >
                                                                            <Card className="p-3 rounded card-custom-bg">
                                                                                <div className="d-flex justify-content-between align-items-center border-bottom pb-2">
                                                                                    <div>
                                                                                        <h5 className="m-0 text-dark">
                                                                                            {item?.serviceOrganizationName
                                                                                                ? item?.serviceOrganizationName
                                                                                                : ''}
                                                                                        </h5>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="mt-3">
                                                                                    <div className="d-flex align-items-center">
                                                                                        <i className="ri-map-pin-fill text-danger fs-3"></i>
                                                                                        <div className="fs-6 ms-2">
                                                                                            {item?.location ? item?.location : '-'}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="d-flex align-items-center mt-2">
                                                                                        <i className="ri-phone-fill text-success fs-3"></i>
                                                                                        <p className="fs-6 m-0 ms-2">
                                                                                            {item?.phone ? item?.phone : '-'}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="d-flex align-items-center mt-2">
                                                                                        <i className="ri-mail-fill text-warning fs-3"></i>
                                                                                        <p className="fs-6 m-0 ms-2">
                                                                                            {item?.email ? item?.email : '-'}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="d-flex align-items-center mt-2">
                                                                                        <i className="ri-global-fill text-info fs-3"></i>
                                                                                        <a
                                                                                            href={
                                                                                                item?.website?.startsWith('http')
                                                                                                    ? item?.website
                                                                                                    : `http://${item?.website}`
                                                                                            }
                                                                                            className="fs-6 m-0 ms-2 text-info"
                                                                                            target="_blank"
                                                                                            rel="noopener noreferrer"
                                                                                        >
                                                                                            {item?.website ? item?.website : '-'}
                                                                                        </a>
                                                                                    </div>
                                                                                    <div className="d-flex align-items-center mt-2">
                                                                                        <i className="ri-calendar-line text-success fs-3"></i>
                                                                                        <p className="fs-6 m-0 ms-2">
                                                                                            {item?.pcpAppointmentDate
                                                                                                ? dateInRequireFormate(
                                                                                                      item?.pcpAppointmentDate,
                                                                                                      'm/d/y/hh:mm'
                                                                                                  )
                                                                                                : '-'}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="d-flex align-items-center mt-2">
                                                                                        <i className="ri-sticky-note-line text-info fs-3"></i>
                                                                                        <p className="fs-6 m-0 ms-2" style={textWrap}>
                                                                                            {item?.notes ? item?.notes : '-'}
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                            </Card>
                                                                        </Col>
                                                                    ))}
                                                                </Row>
                                                            </>
                                                        ) : (
                                                            <div className="p-5 text-center">
                                                                <div>A resource is not yet available for this need.</div>
                                                                <div>
                                                                    As soon as your care plan is updated, we will notify you using your
                                                                    preferred communication method.
                                                                </div>
                                                            </div>
                                                        ))}
                                                </Card>
                                            </Col>
                                        ))}
                                    </>
                                ) : (
                                    <>
                                        <div className="d-flex justify-content-center align-items-center">
                                            <img src={noDataImg} alt="pdf-img" className="img-fluid" />
                                        </div>
                                        <div className="p-5 text-center">
                                            <div>A resource is not yet available for this need.</div>
                                            <div>
                                                As soon as your care plan is updated, we will notify you using your preferred communication
                                                method.
                                            </div>
                                        </div>
                                    </>
                                )}
                            </>
                        ) : (
                            <>
                                <div className="d-flex justify-content-center align-items-center">
                                    <img src={noDataImg} alt="pdf-img" className="img-fluid" />
                                </div>
                                <div className="p-5 text-center">
                                    <div>A resource is not yet available for this need.</div>
                                    <div>
                                        As soon as your care plan is updated, we will notify you using your preferred communication method.
                                    </div>
                                </div>
                            </>
                        )}
                    </Row>
                    <div className="d-none download-action-pdf" id="actionPdf">
                        <ActionPlanPDf dataForPDf={finalData} pdfFor={environment} Content={Content} />
                    </div>
                </Container>
            )}

            <div className="mb-5"></div>
            <StaticFooter />
        </>
    );
};

export default MainPage;
